<template>
  <div>  
    <OverlayPanel
      :ref="'op'"
      @click="toggle"
      appendTo="body"
      :showCloseIcon="true"
      id="overlay_panel"
      style="width: 700px"
    >
      <Button style="float: left;" label="View Customer" icon="pi pi-search" @click="viewCustomer"/>
      <Button style="float: right;" label="View Full History" icon="pi pi-inbox" @click="viewFullHistory"/>
      <br />
      <br />
      <HistoryTable
        :data="customerHistory"
        :name="'Customer History'"
        :loading="customerHistoryLoading"
        :customer="tempCustomer"
      />
    </OverlayPanel>

    <OverlayPanel
      :ref="'opActions'"
      @click="toggle"
      appendTo="body"
      :showCloseIcon="true"
      id="overlay_panel"
      style="width: 150px;"
      :baseZIndex=-10
    >
      <div style="padding: 0px 1px">
        <div class="row" style="background-color: white;">
          <div class="col col-lg-12 col-md-12">
            <Button 
              v-for="(obj, index) in getButtons(selectedRow)" 
              :key="index" 
              :label="obj.label" 
              :icon="obj.icon"
              class="p-button-text p-button-plain" 
              @click="obj.command()"
            />
          </div>
        </div>
      </div>
    </OverlayPanel>

    <!-- <div :style="'height: 10px; background-color: black; width: ' + dateTableWidth + ';'">
    </div>
    <br />
    <div :style="'height: 10px; background-color: black; width: 93%;'">
    </div>
    <br />
    <div style="height: 10px; background-color: black; width: 93%;">
    </div>
    <br /> -->
      <!-- :style="{ 'width': this.staticMenuDesktopInactive ? '100%' : '93%' }" -->
    <DataTable 
      :value="contacts"
      :paginator="true"
      dataKey="contactId"
      class="p-datatable-striped p-datatable-sm p-datatable-gridlines p-datatable-customers"
      :rows="50"
      :rowHover="true"
      :selection.sync="selectedContacts"
      :filters="filters"
      :loading="loading"
      paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
      :rowsPerPageOptions="[25, 50, 100]"
      currentPageReportTemplate="{first} to {last} of {totalRecords} Contacts"
      :scrollable="true"
      frozenWidth="50px"
      scrollHeight="400px"
      :resizableColumns="true" 
      columnResizeMode="expand"
    >
      <template #empty> No contacts found. </template>
      <template #loading> Loading contacts data. Please wait. </template>
      <!-- <Column selectionMode="multiple" headerStyle="width: 3em;"></Column> -->
      <Column 
        header="Actions"
        headerStyle="width: 50px; padding: 7.5px 0px;"
        :frozen="true"
      >
        <template #body="slotProps">
          <div  
            style="height: 26px; display: flex; align-items: center;"
          >
            <Button 
              icon="pi pi-ellipsis-h" 
              class="p-button-rounded p-button-text"
              @click="toggleActions($event, slotProps.data)"
            />
          </div>
        </template>
      </Column>
      <Column 
        v-for="(col, index) of colSelectedFieldsForTable" 
        :key="col.dbField + '_' + index"
        :field="getOptionLabel(col)[0]" 
        :header="col.fieldName" 
        :sortable="true"
        :headerStyle="'width: ' + col.defWidth + 'px; padding: 7.5px 0px;'" 
      >
        <template #body="slotProps">
          <div
            @click="openOP(slotProps.data, col, $event)"
            :class="getStyle2(col)"
            style="height: 26px; display: flex; align-items: center;"
          >
            {{ getToShow(slotProps.data, col) }}
          </div>
        </template>
      </Column>
    </DataTable>

    <Dialog header="Confirm" :visible.sync="deleteConfirmation" :style="{width: '350px'}" :modal="true">
      <div class="confirmation-content">
        <i class="pi pi-info-circle p-mr-3" style="font-size: 2rem" />
        <span>Do you want to delete this contact: {{ tempObj.contactName }}</span>
      </div>
      <template #footer>
        <Button label="Cancel" icon="pi pi-times" @click="deleteConfirmation = false" class="p-button-text" />
        <Button label="Ok" icon="pi pi-check" @click="deleteConfirmation = false, $emit('delete-contact', tempObj)" class="p-button-text" autofocus />
      </template>
    </Dialog>
  </div>
</template>

<script>
import FiltersService from "@/service/FiltersSerice"
import CustomerService from "@/service/CustomerService"

import HistoryTable from '../customer/customerHistoryTable'

import {
  columnSelectionRequest
} from '../sendRequest'

export default {
  components: {
    HistoryTable
  },
  props: [
    "dbView",
    'contacts', 
    'loading',
    "colSelectedFieldsForTable", 
    "colSelectedFields", 
    "dbViewFields"
  ],
  data() {
    return {
      filtersService: new FiltersService(),
      customerService: new CustomerService(),
      selectedContacts: null,
      filters: {
        global: ''
      },
      selected: [],
      customerHistory: [],
      customerHistoryLoading: false,
      tempCustomer: {},
      sendingRequest: false,
      selectedRow: null,
      tempObj: {},
      deleteConfirmation: false
    }
  },
  // computed: {
  //   staticMenuDesktopInactive() {
  //     return this.$store.getters.getStaticMenuDesktopInactive;
  //   }
  // },
  created() {
    this.filters.global = this.$route.query.search
  },
  watch: {
    selected(val) {
      
      if (val && val[0] && val[0].id) {
        this.sendingRequest = false
        columnSelectionRequest(this, 'ContactsTable.vue')
      }
    },
    contacts(val) {
      
      this.customersTableKey++
    },
    colSelectedFieldsForTable(val) {
      
      this.customersTableKey++
      // setTimeout(() => this.colSelectedFieldsForTable.forEach(a => 
    }
  },
  methods: {
    async toggle(event) {
      this.$refs.op.toggle(event);
    },
    toggleActions(event, data) {
      this.selectedRow = data
      this.$refs.opActions.toggle(event);
    },
    openOP(data, col, event) {
      
      
      if (col.dbField === 'custName' && data && data.customerId) {
        this.tempCustomer = data
        this.customerHistory = []
        this.customerHistoryLoading = true
        this.customerService
          .getCustomerHistory(data.customerId)
          .then(data => {
            if (data.length > 20) {
              this.customerHistory = data.slice(0, 20);
            } else {
              this.customerHistory = data
            }
            this.customerHistoryLoading = false
          })
          .catch(err => {
            this.customerHistoryLoading = false
            // this.$toast.add({
            //   severity: "error",
            //   summary: "Error",
            //   detail: "Error while getting customer history.",
            //   life: 5000,
            // })
            this.$store.dispatch('addErrorMessage', {
              severity: 'error',
              content: 'Some data was not loaded from "getCustomerHistory/{customerId}"'
            })
          })
        this.toggle(event);
      }
    },
    getStyle2(col) {
      if (
        col.dbField === 'custName'
      ) {
        return 'under_lined'
      }
    },
    getToShow(data, col) {
      let a = col.dbField.split('.')
      // 
      if (a.length > 1) {
        return data[a[0]] ? data[a[0]][a[1]] : ''
      } else {
        return data[col.dbField]
      }
    },
    getOptionLabel(data){
      if (data) {
        if (data.dbNameField) {
          return [data.dbNameField]
        } else {
          return data ? data.dbField.split('.').slice(-1) : []
        }
      }
    },
    viewFullHistory() {
      if (this.tempCustomer && this.tempCustomer.customerId)
        this.$router.push({
          path: "/customers/" + this.tempCustomer.customerId + "/history",
          params: { custid: this.tempCustomer.customerId },
        });
    },
    viewCustomer() {
      if (this.tempCustomer && this.tempCustomer.customerId)
        this.$router.push({
          path: "/customers/" + this.tempCustomer.customerId + "/detail",
          params: { custid: this.tempCustomer.customerId },
        });
    },
    getButtons(data) {
      let buttons = [
				{
					label: 'View',
					icon: 'pi pi-info',
					command: () => {
						this.viewContact(data)
					}
				},
				{
					label: 'Edit',
					icon: 'pi pi-pencil',
					command: () => {
						this.editContact(data)
					}
				}
      ]

        buttons.push(
          {
            label: 'Delete',
            icon: 'pi pi-trash',
            command: () => {
              this.deleteContact(data)
            }
          }
        )
      return buttons
    },
    viewContact(contact) {
      this.$store.dispatch('contacts/setContactDetailsForTab', contact)
      this.$router.push({
        path: "/contacts/" + contact.contactId + "/detail",
        params: { contactId: contact.contactId },
        // query: { contact: contact }
      });
    },
    deleteContact(contact) {
      this.tempObj = contact
      this.deleteConfirmation = true
    },
    viewContact(contact) {
      this.$store.dispatch('contacts/setContactDetailsForTab', contact)
      // push, not replace: replacing overwrote the customer's entry in history, so Back
      // from the contact skipped the customer it was opened from (the Activities list had
      // the same fault - see MyActivityTableForLazyLoadingWithResize).
      this.$router.push({
        path: "/contacts/" + contact.contactId + "/detail",
        params: { contactId: contact.contactId },
        // query: { contact: contact }
      });
    },
    editContact(contact) {
      this.$emit('edit-contact', contact)
    }
  }
}
</script>

<style scoped>

</style>